var React = require('react');

function UmbrellaOpen60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M60 26.846C60 28.455 58.551 30 57 30H31v20.19c0 4.845-4.143 8.789-9.234 8.789-5.079 0-8.766-3.593-8.766-8.54a.999.999 0 1 1 2 0c0 3.791 2.846 6.544 6.766 6.544 3.989 0 7.234-3.048 7.234-6.793V30H3c-1.579 0-3-1.493-3-3.106C0 13.274 14.424 6.006 29 5.687V.974a1 1 0 1 1 2 0v4.713c14.575.318 29 7.569 29 21.159zM30 7.669c-13.914 0-28 6.604-28 19.225C2 27.348 2.49 28 3 28h26.625a.996.996 0 0 1 .375-.076c.133 0 .259.029.375.076H57c.487 0 1-.694 1-1.154C58 14.257 43.914 7.669 30 7.669z","key":1})]);
}

UmbrellaOpen60px.displayName = "UmbrellaOpen60px";

UmbrellaOpen60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 59"};

module.exports = UmbrellaOpen60px;

UmbrellaOpen60px.default = UmbrellaOpen60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/umbrella-open-60px.svg
// module id = 1221
// module chunks = 0